// extracted by mini-css-extract-plugin
export default {"mainTr":"TableRowCategoryWithCollapse_mainTr__7vwlj","hoverTr":"TableRowCategoryWithCollapse_hoverTr__2Y6dS","collapseTr":"TableRowCategoryWithCollapse_collapseTr__3swQO"};